import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../components/store/Store';
import SettingsInputContainer from '../../../components/SettingsInputContainer';
import TextInput from '../../../components/forms/TextInput';
import Container from '../../../components/Container';
import CheckboxInput from '../../../components/forms/CheckboxInput';

export const WebPageContactInfoSettings: FC = () => {
  const { t } = useTranslation('components');
  const { state } = useStore();
  const isSuperAdmin = state.currentUser?.user?.is_super_admin;

  return (
    <>
      <SettingsInputContainer title={t(`Settings.WebpageSettings.WebpageContactInfoSettings.title`)}>
        <Container fullWidth gap={2} column left>
          <Container column left fullWidth>
            <Typography>{t(`Settings.WebpageSettings.WebpageContactInfoSettings.description`)}</Typography>
          </Container>
          <Container fullWidth column top left gap={2}>
            <TextInput
              path='content.settings.footer.text'
              label={t('Settings.LanguageSettings.LanguageFooterSettings.text')}
              defaultValue=''
            />
            <TextInput
              path='content.settings.footer.name'
              label={t('Settings.LanguageSettings.LanguageFooterSettings.name')}
              defaultValue=''
            />
            <Container fullWidth spaceBetween>
              <TextInput
                path='content.settings.footer.address'
                label={t('Settings.LanguageSettings.LanguageFooterSettings.address')}
                defaultValue=''
              />
            </Container>
            <Container fullWidth spaceBetween>
              <TextInput
                path='content.settings.footer.postalCode'
                label={t('Settings.LanguageSettings.LanguageFooterSettings.postalCode')}
                defaultValue=''
              />
              <TextInput
                path='content.settings.footer.postalPlace'
                label={t('Settings.LanguageSettings.LanguageFooterSettings.postalPlace')}
                defaultValue=''
              />
            </Container>
            <Container fullWidth spaceBetween>
              <TextInput
                path='content.settings.footer.email'
                label={t('Settings.LanguageSettings.LanguageFooterSettings.email')}
                defaultValue=''
              />
              <TextInput
                path='content.settings.footer.phone'
                label={t('Settings.LanguageSettings.LanguageFooterSettings.phone')}
                defaultValue=''
              />
              <TextInput
                path='content.settings.footer.mobile'
                label={t('Settings.LanguageSettings.LanguageFooterSettings.phone')}
                defaultValue=''
              />
            </Container>
          </Container>

          <strong>Kontaktdata ved arrangementseksport (hvis annet enn ovenfor)</strong>

          <Container fullWidth spaceBetween>
            <TextInput
              path='content.settings.booking.email'
              label={t('Settings.LanguageSettings.LanguageFooterSettings.email')}
              defaultValue=''
            />
            <TextInput
              path='content.settings.booking.phone'
              label={t('Settings.LanguageSettings.LanguageFooterSettings.phone')}
              defaultValue=''
            />
            <TextInput
              path='content.settings.booking.link'
              label={t('Settings.LanguageSettings.LanguageFooterSettings.link')}
              defaultValue=''
            />
          </Container>
        </Container>
      </SettingsInputContainer>
    </>
  );
};

export default WebPageContactInfoSettings;
